import { AuthenticationService, ConfigurationService, ExperimentalFlagsService, HttpService, LanguageService, LocaleService, MessageService, TextToSpeechService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { loadAuthentication } from './authentication.js';
import { loadBootstrapConfiguration } from './bootstrap-configuration.js';
import { getModules, registerModules } from './modules.js';
async function loadConfiguration() {
    await ConfigurationService.initialize();
    if (!LocaleService.hasBeenInitialized() || !import.meta.hot) {
        await LocaleService.initialize();
    }
    if (!LanguageService.hasBeenInitialized() || !import.meta.hot) {
        await LanguageService.initialize();
    }
    if (!HttpService.hasBeenConfigured() || !import.meta.hot) {
        HttpService.configure({
            authentication: AuthenticationService,
            base: ConfigurationService.getBaseURL(),
        });
    }
}
async function loadExperimentalFlags() {
    if (ExperimentalFlagsService.hasBeenInitialized()) {
        return;
    }
    // @ts-expect-error
    const { get } = await import('virtual:oswald-experimental-flags');
    const experimentalFlags = await get() ?? {};
    ExperimentalFlagsService.initialize(experimentalFlags);
}
function loadTextToSpeech() {
    if (TextToSpeechService.hasBeenInitialized()) {
        return;
    }
    TextToSpeechService.initialize();
}
async function loadMessages() {
    if (MessageService.hasBeenInitialized() && import.meta.hot) {
        return;
    }
    return await MessageService.initialize();
}
async function loadMetadata(engine) {
    // @ts-expect-error
    const { get } = await import('virtual:oswald-fragments');
    const fragments = await get();
    for (const { name, metadata } of fragments) {
        engine.registerMetadata(name, metadata);
    }
}
async function loadModules() {
    const modules = await getModules();
    await registerModules(modules);
}
async function bootstrap(options) {
    const { engine } = options;
    // needs to finish before loading the rest
    await loadConfiguration();
    loadTextToSpeech();
    await Promise.all([
        loadMessages(),
        loadMetadata(engine),
        loadModules(),
        loadAuthentication(),
        loadExperimentalFlags(),
        loadBootstrapConfiguration(),
    ]);
}
export { bootstrap, };
//# sourceMappingURL=bootstrap.js.map